"use client";

import { useState } from "react";
import Text from "@components/atoms/Text";
import styles from "./ExpandableSection.module.scss";

interface ExpandableSectionProps {
  heading: string;
  description: string;
  headingLevel?: "h2" | "h3" | "p";
  headingClassName?: string;
  descriptionClassName?: string;
  defaultExpanded?: boolean;
}

export default function ExpandableSection({
  heading,
  description,
  headingLevel = "h3",
  headingClassName = "",
  descriptionClassName = "",
  defaultExpanded = false,
}: ExpandableSectionProps) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={styles.container}>
      <button
        className={styles.header}
        onClick={toggleExpanded}
        aria-expanded={isExpanded}
        type="button"
      >
        <Text level={headingLevel} className={`${styles.heading} ${headingClassName}`}>
          {heading}
        </Text>
        <span className={`${styles.arrow} ${isExpanded ? styles.arrowExpanded : ""}`}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 7.5L10 12.5L15 7.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      </button>
      <div className={`${styles.content} ${isExpanded ? styles.contentExpanded : styles.contentCollapsed}`}>
        <Text level="p" className={`${styles.description} ${descriptionClassName}`}>
          {description}
        </Text>
      </div>
    </div>
  );
}
